import { io } from "socket.io-client";

export default class Events {

    constructor(sdk) {
        this._sdk = sdk;
        this.connected = false;
    }

    connect(token) {

        if(this.connected)
            return this._socket;

        return new Promise((resolve, reject) => {
            this._socket = io(this._sdk.getApiUrl(), {
                auth: {
                    token
                }
            });
            
            this._socket.on('connect', () => {  
                this.connected = true;              
                resolve(this._socket);
            })

            this._socket.on('disconnect', () => {  
                
            })

            this.listeners();

        });
    }

    disconnect() {
        this._socket.disconnect();
    }

    listeners() {    

        this._socket.on('newSession', (data) => {
            if(window.sdk.session().isPatient() && data.id != this._socket.id && data.role == 'patient') {
                //window.sdk.exit();
                //window.sdk.event().emit('killed');
                this._socket.emit('mustILeave', 'patient');
            }

            if(window.sdk.session().isExtern() && data.id != this._socket.id && data.role == 'extern') {
                //window.sdk.exit();
                //window.sdk.event().emit('killed');
                this._socket.emit('mustILeave', 'extern');
            }

        });

        this._socket.on('mustILeave', async (data) => {
            if(data.type == 'patient' && window.sdk.session().isPatient() && data.id != this._socket.id) {
                while(window.sdk.session().waitingValidation) {
                    await window.sdk.sleep(300);
                }
                window.sdk.event().emit('modalOpen', {
                      variant: 'confirm',
                      title: 'Vous êtes déjà connecté sur une autre fenêtre',
                      content: 'Voulez vous déconnecter l\'utilisateur existant ?',
                      onCancel: () => { 
                        window.sdk.event().emit('modalClose')
                        window.sdk.exit();
                        window.sdk.event().emit('killed',{reason:'keepCurrentTab'});
                      },
                      onConfirm: () => { 
                        window.sdk.event().emit('modalClose')
                        this._socket.emit('disconnectPatientDoublon', data.id);
                      }
                });
            }
            if(data.type == 'extern' && window.sdk.session().isExtern() && data.id != this._socket.id) {
                while(window.sdk.session().waitingValidation) {
                    await window.sdk.sleep(300);
                }
                window.sdk.event().emit('modalOpen', {
                      variant: 'confirm',
                      title: 'Vous êtes déjà connecté sur une autre fenêtre',
                      content: 'Voulez vous déconnecter l\'utilisateur existant ?',
                      onCancel: () => { 
                        window.sdk.event().emit('modalClose')
                        window.sdk.exit();
                        window.sdk.event().emit('killed',{reason:'keepCurrentTab'});
                      },
                      onConfirm: () => { 
                        window.sdk.event().emit('modalClose')
                        this._socket.emit('disconnectPatientDoublon', data.id);
                      }
                });
            }
        });

        this._socket.on('disconnectPatientDoublon', (data) => {
            if(data.id == this._socket.id) {
                window.sdk.exit();
                window.sdk.event().emit('killed',{reason:'openInNewTab'});
            }

        });
        
        this._socket.on('newSessionToValidate', (data) => {
            if(window.sdk.session().getName() == 'medecin' && window.sdk.session().session.validate_fromadmin)
                window.sdk.event().emit('newSessionToValidate', data);
        });

        this._socket.on('newSessionIsValidate', (data) => {

            if(data.socketId == this._socket.id) {
                window.sdk.event().emit('iAmValidate');
                window.sdk.session().waitingValidation = false;
            }
            
            if(window.sdk.session().getName() == 'medecin')
                window.sdk.event().emit('removeNotification', data.socketId);
        });

        this._socket.on('newSessionIsRefused', (data) => {

            if(data.socketId == this._socket.id) {
                window.sdk.event().emit('iAmRefuse');
            }

        });        
        
        this._socket.on('newMessage', (data) => {
            this._sdk.chat().addMessage(data.message);
            window.sdk.event().emit('newMessage',data);
        })

        this._socket.on('deleteMessage', (data) => {
            this._sdk.chat().deleteMessage(data.message);
            window.sdk.event().emit('deleteMessage',data.message);
        })

        this._socket.on('killed', () => {
            window.sdk.event().emit('killed');
        })

        this._socket.on('disconnectedPeer', (data) => {
            window.sdk.videoconf().removeFakeConsumer(data)
        })

        this._socket.on('infoUpdate', (data) => {
            if(window.sdk.session().token !== data.token)
                window.sdk.event().emit('infoUpdate',data.infos);
        })
    }
}